import { useTranslate } from "@similarweb/i18n-provider";
import type { IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import ManagementCard
    from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCard";
import {
    StyledManagementCardButton
} from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";
import manageIntegrationsTrackingService
    from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import openExternalLink from "app/pages/sales-intelligence/modules/manage-integrations/utils/openExternalLink";
import { MANAGEMENT_COMMON_CONNECT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

interface IProps {
    titleKey: string;
    iconName: IconName;
    descriptionKey: string;
    connectLink: string;
    guideLink: string;
    trackingName: string;
    dataAutomation: string;
}

const ConnectorCard = ({
    titleKey,
    iconName,
    descriptionKey,
    connectLink,
    guideLink,
    trackingName,
    dataAutomation
}: IProps): React.ReactElement => {
    const { translate } = useTranslate();

    const handleGuideClick = () => {
        manageIntegrationsTrackingService.trackConnectorGuideClick(trackingName);
        openExternalLink(guideLink);
    };

    const connectButton = (
        <Stack>
            <StyledManagementCardButton
                buttonHtmlType="button"
                type="primary"
                onClick={() => openExternalLink(connectLink)}
                data-automation={`${dataAutomation}.connector-card-connect-button`}
            >
                {translate(MANAGEMENT_COMMON_CONNECT)}
            </StyledManagementCardButton>
        </Stack>
    );

    return (
        <ManagementCard
            dataAutomation={dataAutomation}
            title={translate(titleKey)}
            titleIconName={iconName}
            onHeaderActionClick={handleGuideClick}
            footer={connectButton}
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon["300"]}
            >
                {translate(descriptionKey)}
            </Text>
        </ManagementCard>
    );
};

export default ConnectorCard;
